document.addEventListener("DOMContentLoaded", () => {
  const openMobileMenu = document.getElementById("openMobileMenu");
  const closeMobileMenu = document.getElementById("closeMobileMenu");
  const mobileNav = document.getElementById("mobileNav");
  openMobileMenu.addEventListener("click", () => {
    mobileNav.classList.remove("hidden");
    openMobileMenu.classList.add("hidden");
    closeMobileMenu.classList.remove("hidden");
  });

  closeMobileMenu.addEventListener("click", () => {
    mobileNav.classList.add("hidden");
    openMobileMenu.classList.remove("hidden");
    closeMobileMenu.classList.add("hidden");
  });
});

function openSearchSidebarButtons(element) {
  const searchContainer = document.querySelector("#search-container");
  if (!searchContainer) return;
  searchContainer.classList.remove("hidden");
  searchContainer.classList.add("fixed");
}
